import {ElementUtil} from '../../utils/elementUtil.js';

export function showMigrationStep3Dialog(record, migrationService, onRefresh) {
	var finalizeButton;
	var dialog = ElementUtil.create({
		tag: 'dl-dialog',
		title: 'Step 3 - Finalization',
		icon: 'vaadin:flag-checkered',
		width: .7,
		height: .75,
		listeners: {
			ready: function() {
				dialog.show();

				var contentPanel = ElementUtil.create({
					tag: 'div',
					style: 'overflow: auto; padding-right: 4px;'
				});

				var cleanupMonths = record && record.inactiveUnitMonths != null
					? record.inactiveUnitMonths
					: 6;
				var workflowItems = [
					'Update V8 account billing based on the original V6 billable status',
					'Stop V6 integrations (set to inactive)',
					'Sync integration pull dates from V6',
					'Activate pending V8 integrations',
					'Set V6 company billing to Do Not Bill'
				];
				if (record && record.cleanupInactiveUnits) {
					workflowItems.push(
						'Auto-retire inactive tractors with no activity in the last '
							+ cleanupMonths + ' month(s)'
					);
				}
				workflowItems.push('Set V6 data locks for the previous and current months');

				var workflowSummary = ElementUtil.create({
					tag: 'div',
					style: 'margin-bottom: 16px;',
					trustedInnerHTML: true,
					innerHTML: '<strong>On finalize, the system will:</strong><ol style="margin: 8px 0 0 0;">'
						+ workflowItems.map(function(item) {
							return '<li>' + item + '</li>';
						}).join('')
						+ '</ol>'
				});
				contentPanel.appendChild(workflowSummary);

				var changesPanel = ElementUtil.create({
					tag: 'fieldset',
					style: 'margin: 0 0 12px 0; padding: 12px;',
					children: [
						{tag: 'legend', innerHTML: 'Changes that will occur'},
						{
							tag: 'div',
							itemid: 'changesContent',
							style: '',
							innerHTML: 'Loading change preview...'
						}
					]
				});
				contentPanel.appendChild(changesPanel);

				var changesContent = ElementUtil.query(changesPanel, 'changesContent');

				migrationService.getFinalizePreview(record.migrationId).then(function(result) {
					var preview = result.data || result || {};
					changesContent.innerHTML = buildChangesHtml(preview);
				}).catch(function() {
					changesContent.innerHTML = '<div>Unable to load change preview. '
						+ 'You can still finalize, or close and try again.</div>';
				});

				var buttonBar = ElementUtil.create({
					tag: 'div',
					style: 'margin-top: 16px; text-align: center;',
					defaults: {tag: 'vaadin-button'},
					children: [
						{
							itemid: 'finalize',
							theme: 'primary',
							children: [ElementUtil.makeIcon('vaadin:check', ' Finalize Migration')],
							postinit: function(button) {
								finalizeButton = button;
							},
							listeners: {
								click: function() {
									window.DL.MessageUtil.showConfirm({
										title: 'Finalize Migration',
										message: 'After finalization, this company is fully migrated. '
											+ 'Any further changes must be handled manually via the company or an admin.\n\nProceed?',
										buttons: [
											{text: 'Cancel'},
											{
												text: 'Finalize',
												theme: 'primary',
												handler: function() {
													if (finalizeButton) {
														finalizeButton.disabled = true;
													}
													migrationService.finalizeMigration(record.migrationId, {
														confirmed: true
													}).then(function() {
														window.DL.MessageUtil.showToast('Success', 'Migration finalized', {theme: 'success'});
														dialog.close();
														if (onRefresh) {
															onRefresh();
														}
													}).catch(function() {
														if (finalizeButton) {
															finalizeButton.disabled = false;
														}
													});
												}
											}
										]
									});
								}
							}
						},
						{
							theme: 'tertiary',
							style: 'margin-left: 10px;',
							innerHTML: 'Close',
							listeners: {
								click: function() {
									dialog.close();
								}
							}
						}
					]
				});
				dialog.addToContentElement(contentPanel);
				dialog.addToContentElement(buttonBar);
			}
		}
	});
}

function buildChangesHtml(preview) {
	var v6BillingStatus = preview.v6BillingStatus || 'Do Not Bill';
	var v8Integrations = Array.isArray(preview.v8IntegrationsToActivate)
		? preview.v8IntegrationsToActivate
		: [];
	var v6Integrations = Array.isArray(preview.v6IntegrationsToDeactivate)
		? preview.v6IntegrationsToDeactivate
		: [];
	var dataLockMonths = Array.isArray(preview.dataLockMonths) ? preview.dataLockMonths : [];

	var checkIcon = '<vaadin-icon icon="vaadin:check-circle" style="color: green; '
		+ 'vertical-align: -2px; margin-right: 6px; flex-shrink: 0;"></vaadin-icon>';
	var html = '<ul style="margin: 0; padding-left: 0; list-style: none; line-height: 1.6;">';

	html += '<li style="display: flex; align-items: flex-start; margin-bottom: 4px;">'
		+ checkIcon + '<span>' + escapeHtml(preview.accountBillingSummary
		|| 'Billing will be updated.') + '</span></li>';

	html += '<li style="display: flex; align-items: flex-start; margin-bottom: 4px;">'
		+ checkIcon + '<span><strong>V6 Integration(s)</strong> — the following will be set to <strong>Inactive</strong>:';
	html += formatNameList(v6Integrations, 'No active V6 integrations to deactivate.');
	html += '</span></li>';

	html += '<li style="display: flex; align-items: flex-start; margin-bottom: 4px;">'
		+ checkIcon + '<span><strong>Integration(s)</strong> — the following will be set to <strong>Active</strong>:';
	html += formatNameList(v8Integrations, 'No pending integrations to activate.');
	html += '</span></li>';

	html += '<li style="display: flex; align-items: flex-start; margin-bottom: 4px;">'
		+ checkIcon + '<span><strong>V6 Company Billing</strong> will be set to <strong>'
		+ escapeHtml(v6BillingStatus) + '</strong></span></li>';

	if (preview.cleanupInactiveTractors) {
		html += '<li style="display: flex; align-items: flex-start; margin-bottom: 4px;">'
			+ checkIcon + '<span><strong>Inactive tractors</strong> — '
			+ escapeHtml(preview.cleanupInactiveTractorsSummary
				|| 'Inactive tractors will be auto-retired.')
			+ '</span></li>';
	}

	html += '<li style="display: flex; align-items: flex-start; margin-bottom: 4px;">'
		+ checkIcon + '<span><strong>Data Locks</strong> will be set for ';
	if (dataLockMonths.length === 0) {
		html += 'the previous and current months.';
	} else if (dataLockMonths.length === 1) {
		html += '<strong>' + escapeHtml(dataLockMonths[0]) + '</strong>.';
	} else {
		html += '<strong>' + escapeHtml(dataLockMonths[0]) + '</strong> and <strong>'
			+ escapeHtml(dataLockMonths[1]) + '</strong>';
		if (dataLockMonths.length > 2) {
			for (var index = 2; index < dataLockMonths.length; index++) {
				html += ', <strong>' + escapeHtml(dataLockMonths[index]) + '</strong>';
			}
		}
		html += '.';
	}
	html += '</span></li>';

	html += '</ul>';
	return html;
}

function formatNameList(names, emptyMessage) {
	if (!names || names.length === 0) {
		return '<div style="color: #555; margin-top: 2px;">' + escapeHtml(emptyMessage) + '</div>';
	}
	var html = '<ul style="margin: 4px 0 0 0; padding-left: 18px;">';
	names.forEach(function(name) {
		html += '<li>' + escapeHtml(name) + '</li>';
	});
	html += '</ul>';
	return html;
}

function escapeHtml(value) {
	if (value == null) {
		return '';
	}
	return String(value)
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;');
}
